import { selectToolbarConfig } from 'core/selectors/app';
import { useSelector } from 'react-redux';
import { selectIsMobileMQ, selectIsDesktopMQ } from 'core/modules/MediaQueries/selectors';
import {
  isChrome, isEdge, isSafari, isIOS,
} from 'core/utils/helpers/browser';

export const useIsButtonEligibleForBrowser = () => {
  const toolbarConfig = useSelector(selectToolbarConfig);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const isDesktopMQ = useSelector(selectIsDesktopMQ);
  const {
    enableButtonMarketing, enableButtonMarketingChrome, enableButtonMarketingSafari, enableButtonMarketingIOS,
  } = toolbarConfig;

  if (!enableButtonMarketing) return false;

  if (isChrome || isEdge) return enableButtonMarketingChrome;
  if (isSafari && isDesktopMQ) return enableButtonMarketingSafari;
  if (isIOS && isMobileMQ) return enableButtonMarketingIOS;

  return false;
};
